import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Alert } from 'react-bootstrap';

import Loader from 'components/layout/Loader';

import List from 'components/List';

class OrderInvoicesPopover extends React.Component {
  render() {
    const { intl, order, list } = this.props;
    const messages = intl.messages;

    let invoiceFound = false;

    return (
      <div style={{ width: '200px' }}>
        <List
          noRender
          listName="orderInvoices"
          url="/api/invoices.json"
          urlData={{ filters: { order: order.id } }}
          list={list}
        />

        {list.pending ? (
          <Loader />
        ) : (
          <div class="p-t-15 p-b-15">
            {list.data.list.map((invoice, i) => {
              if (invoice.pdf && invoice.pdf.web_link) {
                invoiceFound = true;

                return (
                  <div key={i}>
                    <a href="javascript:;">
                      {messages.salesDoc.invoice} #{invoice.number}
                    </a>
                  </div>
                );
              }
            })}

            {!invoiceFound && <Alert class="no-margin">{messages.no_invoices_found}</Alert>}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    list: state.list.orderInvoices,
  };
};

export default injectIntl(connect(mapStateToProps)(OrderInvoicesPopover));
